import React from 'react';
import { ENABLE_FULL_RESPONSIVE } from 'reactApp/appHelpers/configHelpers';
import { BREAKPOINT_SM } from 'reactApp/constants/breakpoints';
import { FeatureSelector } from 'reactApp/modules/features/components/FeatureSelector';
import { getFeatureNewContentGrid } from 'reactApp/modules/features/features.selectors';
import { useWindowWidth } from 'reactApp/ui/VirtualList/VirtualList.hooks';

import styles from '../../DataListItemRow.css';
import newStyles from '../../DataListItemRow.new.css';
import { PublicItemProps } from '../../DataListItemRow.types';
import { Checkbox } from '../Checkbox';
import { Date } from '../Date';
import { Download } from '../Download';
import { ItemName } from '../ItemName';
import { ItemTip } from '../ItemTip/ItemTip';
import { Pic } from '../Pic';
import { Public } from '../RowFor/Public';
import { Size } from '../Size';

const PublicItem = (props: PublicItemProps) => {
    const {
        onCheckboxClick,
        isSelected,
        isFolder,
        thumbUrl,
        kind,
        isVirus,
        ext,
        author,
        tipData,
        name,
        mtime,
        size,
        isPublicDownloaded,
        onDownload,
        id,
        storage,
    } = props;
    const windowWidth = useWindowWidth();

    return (
        <FeatureSelector
            selector={getFeatureNewContentGrid}
            variant1={<Public {...props} checkboxClassname={newStyles.check} />}
            control={
                <>
                    <Checkbox onCheckboxClick={onCheckboxClick} isSelected={isSelected} />
                    <Pic isFolder={isFolder} thumbUrl={thumbUrl} kind={kind} isVirus={!!isVirus} ext={ext || ''} author={author} />

                    {!ENABLE_FULL_RESPONSIVE ? (
                        <>
                            <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                            <ItemName name={name} ext={ext || ''} id={id} />
                            <Date date={mtime} />
                            <Size size={size} />
                            {!isPublicDownloaded && (
                                <Download onClick={onDownload} ext={isFolder ? 'zip' : ext} size={size} id={id} storage={storage} />
                            )}
                        </>
                    ) : (
                        <>
                            {windowWidth > BREAKPOINT_SM ? (
                                <>
                                    <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                </>
                            ) : (
                                <div className={styles.responsiveNameWrapper}>
                                    <ItemTip tipData={tipData} isFolder={isFolder ?? false} />
                                    <ItemName name={name} ext={ext || ''} id={id} />
                                    <span className={styles.responsiveDateWrapper}>
                                        <Size size={size} />
                                        {!!mtime && <>&nbsp;•&nbsp;</>}
                                        <Date date={mtime} />
                                    </span>
                                </div>
                            )}
                            {windowWidth > BREAKPOINT_SM && (
                                <>
                                    {mtime && <Date date={mtime} />}
                                    <Size size={size} />
                                </>
                            )}
                            {!isPublicDownloaded && (
                                <div className={styles.actionsWrapper}>
                                    <Download onClick={onDownload} ext={isFolder ? 'zip' : ext} size={size} id={id} storage={storage} />
                                </div>
                            )}
                        </>
                    )}
                </>
            }
        />
    );
};

export default PublicItem;
